<div
    class="warning mb-2 p-2 flex justify-content-center"
    *ngIf="(authService.me | async)?.note"
>
    {{ (authService.me | async).note }}
</div>
<section class="main-app">
    <app-nav-bar class="d-md-none"></app-nav-bar>
    <div class="app-grid">
        <div class="app-side-bar">
            <app-side-bar></app-side-bar>
        </div>
        <div class="app-main-content">
            @if ((authService.runApplicationLoader | async) && authService.requestCountSubject$.getValue() !== 0) {
            <p-progressBar
                class="app-progress"
                mode="indeterminate"
                [style]="{ height: '4px' }"
            ></p-progressBar>
            }
            <router-outlet></router-outlet>
        </div>
    </div>
</section>